const items = {
  "term.fields.sn.label": "序号",
  "term.fields.word.label": "词头",
  "term.fields.description.label": "标签",
  "term.fields.description.tooltip":
    "单词说明，可以用来区分相同拼写的不同单词。",
  "term.fields.channel.label": "所属版本",
  "term.fields.channel.tooltip": "该术语仅仅用于某个版本",
  "term.fields.meaning.label": "意思",
  "term.fields.meaning.tooltip": "单词的首选意思",
  "term.fields.meaning2.label": "其他意思",
  "term.fields.meaning2.tooltip": "其他意思将出现在后面的括号里",
  "term.fields.note.label": "注释",
  "term.general-in-studio": "通用于本Studio",
};

export default items;
